import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { FiShoppingCart, FiUser, FiLogOut, FiShield } from 'react-icons/fi';
import { AuthContext } from '../context/AuthContext';
import { CartContext } from '../context/CartContext';

const Navbar = () => {
  const { isAuthenticated, user, logout } = useContext(AuthContext);
  const { cartCount } = useContext(CartContext);

  return (
    <nav className="bg-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="relative">
              <span className="text-2xl font-black bg-gradient-to-r from-blue-600 via-purple-600 to-orange-600 bg-clip-text text-transparent animate-gradient">
                CryptoCashFast
              </span>
            </Link>
            <style>{`
              @keyframes gradient {
                0%, 100% {
                  background-position: 0% 50%;
                }
                50% {
                  background-position: 100% 50%;
                }
              }
              .animate-gradient {
                background-size: 200% 200%;
                animation: gradient 3s ease infinite;
              }
            `}</style>
            <div className="ml-10 flex space-x-4">
              <Link to="/catalog" className="text-gray-700 hover:text-primary px-3 py-2 rounded-md text-sm font-medium">
                Gift Cards
              </Link>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            {isAuthenticated ? (
              <>
                <Link to="/cart" className="relative text-gray-700 hover:text-primary">
                  <FiShoppingCart size={24} />
                  {cartCount > 0 && (
                    <span className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs">
                      {cartCount}
                    </span>
                  )}
                </Link>
                {user?.role === 'admin' && (
                  <Link to="/admin" className="text-purple-600 hover:text-purple-700 flex items-center space-x-1">
                    <FiShield size={20} />
                    <span className="text-sm font-medium">Admin</span>
                  </Link>
                )}
                <Link to="/dashboard" className="text-gray-700 hover:text-primary flex items-center space-x-1">
                  <FiUser size={20} />
                  <span className="text-sm">{user?.name}</span>
                </Link>
                <button
                  onClick={logout}
                  className="text-gray-700 hover:text-primary flex items-center space-x-1"
                >
                  <FiLogOut size={20} />
                  <span className="text-sm">Logout</span>
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="text-gray-700 hover:text-primary px-3 py-2 rounded-md text-sm font-medium">
                  Login
                </Link>
                <Link to="/register" className="bg-primary text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-blue-600">
                  Sign Up
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
